/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddRollupChildRequest
 */
export interface AddRollupChildRequest {
    /**
     * 
     * @type {string}
     * @memberof AddRollupChildRequest
     */
    childInitiativeId: string;
    /**
     * 
     * @type {number}
     * @memberof AddRollupChildRequest
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof AddRollupChildRequest
     */
    rationale?: string;
}

/**
 * Check if a given object implements the AddRollupChildRequest interface.
 */
export function instanceOfAddRollupChildRequest(value: object): value is AddRollupChildRequest {
    if (!('childInitiativeId' in value) || value['childInitiativeId'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    return true;
}

export function AddRollupChildRequestFromJSON(json: any): AddRollupChildRequest {
    return AddRollupChildRequestFromJSONTyped(json, false);
}

export function AddRollupChildRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddRollupChildRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'childInitiativeId': json['childInitiativeId'],
        'weight': json['weight'],
        'rationale': json['rationale'] == null ? undefined : json['rationale'],
    };
}

export function AddRollupChildRequestToJSON(json: any): AddRollupChildRequest {
    return AddRollupChildRequestToJSONTyped(json, false);
}

export function AddRollupChildRequestToJSONTyped(value?: AddRollupChildRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'childInitiativeId': value['childInitiativeId'],
        'weight': value['weight'],
        'rationale': value['rationale'],
    };
}

